import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for PWD512F1 (異常繳庫單核准)
// ============================================================

export interface ApprovalCandidate {
  fd120_01: string; // 繳庫單號
  fd120_11: string; // 繳庫日期
  fd120_12: string; // 供應商代碼
  fd120_13: number; // 繳庫類型
  fd120_17: string; // 部門代碼
  fd120_80: string; // 核准狀態
}

export interface QueryResponse {
  items: ApprovalCandidate[];
  total: number;
}

export interface ApproveResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const pwd512Api = {
  /** Query abnormal storage order candidates eligible for approval */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/pwd512/candidates', { params });
    return res.data;
  },

  /** Execute batch approval for selected abnormal storage orders */
  async approve(items: string[]): Promise<ApproveResponse> {
    const res = await apiClient.post('/api/pwd512/approve', { items });
    return res.data;
  },
};
